(function ($, Cobalt, undefined) {
    'use strict';

    Cobalt.Throttle = {
        isInit: false,
        initialize: function() {
            if (!Cobalt.Throttle.isInit) {
                Cobalt.Throttle.isInit = true;
                window.throttle = throttleFunc;
            } else {
                console.debug('Cobalt.Throttle is being initialized again.')
            }
            return false;
        }
    }

})(jQuery, Cobalt);



function throttleFunc(fn, threshold, scope) {
    threshold || (threshold = 250);
    var last,
        deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date,
            args = arguments;
        if (last && now < last + threshold) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshold + last - now);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Throttle.js